import { z } from "zod";

import { fillTemplate } from "../values/fill-template";
import copyJson from "./order-import-copy.json";

const text = z.string().min(1);
const requestorPolicy = z.object({ issue: text, guide: text });
const example = z.object({ contactName: text, chemicalName: text, notes: text });

const copySchema = z.object({
  dateLabels: z.object({ enteredOn: text, orderedOn: text, fulfilledOn: text }),
  requestorEmail: z.object({ purchase: requestorPolicy, sale: requestorPolicy }),
  dateGuidance: z.object({ optional: text, requiredAll: text, requiredFor: text }),
  rowGuidance: text,
  issues: z.object({
    required: text,
    positiveDecimal: text,
    useOneOf: text,
    requiredForStatus: text,
    expectedColumns: text,
    realDate: text,
    future: text,
    plainDecimal: text,
    validEmail: text,
    precedes: text,
    contactMatch: text,
    requestorMatch: text,
    chemicalAtMostOne: text,
    chemicalCasMismatch: text,
  }),
  contactParty: z.object({ purchase: text, sale: text }),
  fileIssues: z.object({
    unclosedQuote: text,
    headers: text,
    noRows: text,
    tooLarge: text,
    tooManyRows: text,
    duplicate: text,
    confirmRequired: text,
    revalidate: text,
  }),
  examples: z.object({ purchase: example, sale: example }),
});

const copy = copySchema.parse(copyJson);

export const ORDER_IMPORT_DATE_LABELS = copy.dateLabels;
export const ORDER_IMPORT_REQUESTOR_COPY = copy.requestorEmail;
export const ORDER_IMPORT_ROW_GUIDANCE_TEXT = copy.rowGuidance;
export const ORDER_IMPORT_ISSUES = copy.issues;
export const ORDER_IMPORT_CONTACT_PARTY = copy.contactParty;
export const ORDER_IMPORT_FILE_ISSUES = copy.fileIssues;
export const ORDER_IMPORT_EXAMPLES = copy.examples;

export function importDateOptionalGuidance(label: string): string {
  return fillTemplate(copy.dateGuidance.optional, { label });
}

export function importDateRequiredAllGuidance(label: string): string {
  return fillTemplate(copy.dateGuidance.requiredAll, { label });
}

export function importDateRequiredForGuidance(label: string, statuses: string): string {
  return fillTemplate(copy.dateGuidance.requiredFor, { label, statuses });
}

export function importUseOneOfIssue(values: string): string {
  return fillTemplate(copy.issues.useOneOf, { values });
}

export function importRequiredForStatusIssue(status: string): string {
  return fillTemplate(copy.issues.requiredForStatus, { status });
}

export function importExpectedColumnsIssue(count: number): string {
  return fillTemplate(copy.issues.expectedColumns, { count });
}

export function importPrecedesIssue(label: string): string {
  return fillTemplate(copy.issues.precedes, { label });
}

export function importContactMatchIssue(party: string): string {
  return fillTemplate(copy.issues.contactMatch, { party });
}

export function importFileTooLargeIssue(megabytes: number): string {
  return fillTemplate(copy.fileIssues.tooLarge, { megabytes });
}

export function importTooManyRowsIssue(rows: number): string {
  return fillTemplate(copy.fileIssues.tooManyRows, { rows });
}
